import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "src/app/material.module";

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [
    MaterialModule,
    TranslateModule
  ],
  templateUrl: './confirmation-dialog.component.html',

})
export class ConfirmationDialog {
  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string; title: string }
  ) {
  }
  onConfirm(): void {
    this.dialogRef.close("ok");
  }
}